<template>
  <CardContent
    :title="mgnlPropsWithBtnColors.title"
    :title-color="mgnlPropsWithBtnColors.topTitleColor"
    :headline="mgnlPropsWithBtnColors.headline"
    :headline-color="mgnlPropsWithBtnColors.headlineColor"
    :sub-headline="mgnlPropsWithBtnColors.subHeadline"
    :sub-headline-color="mgnlPropsWithBtnColors.subHeadlineColor"
    :switchable-mode="mgnlPropsWithBtnColors.switchableMode"
    :ctas="mgnlPropsWithBtnColors.ctas"
    :image-load-type="mgnlPropsWithBtnColors.imageLoadType"
    :data-ab-id="mgnlProps?.dataABId"
    :enable-legal-disclaimer="mgnlProps?.enableLegalDisclaimer"
    :legal-text="mgnlProps?.legalText"
    :legal-title="mgnlProps?.legalTitle"
    :title-or-subtitle="mgnlProps?.titleOrSubtitle"
  />
</template>

<script lang="ts" setup>
import { CardContentBuilder, WrapperProps } from './CardContent.model';
import CardContent from './CardContent.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);

const {
  titleColor, headlineColor, subHeadlineColor, imageLoadType,
} = toRefs(props);

const mgnlProps = {
  ...CardContentBuilder.build(props),
  imageLoadType: imageLoadType?.value === 'eager' || imageLoadType?.value === 'lazy' ? imageLoadType?.value as ('eager' | 'lazy') : 'eager',
  topTitleColor: magnoliaGetters.getHexColor(titleColor?.value),
  headlineColor: magnoliaGetters.getHexColor(headlineColor?.value),
  subHeadlineColor: magnoliaGetters.getHexColor(subHeadlineColor?.value),
};

const mgnlPropsWithBtnColors = {
  ...mgnlProps,
  ctas: mgnlProps?.ctas?.map(cta => ({
    ...cta,
    titleColor: magnoliaGetters.getHexColor(cta.titleColor),
    buttonColor: magnoliaGetters.getHexColor(cta.buttonColor),
    borderColor: magnoliaGetters.getHexColor(cta.borderColor),
  })),
};
</script>
